import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

const FONT_FAMILY = 'Poppins';
const POPPINS_FONT_BASE_URL = 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/poppins';
//const ZELLE_QR_CODE_URL = 'https://vdointel-ai-storage.s3.us-west-2.amazonaws.com/uploads/logos/vidiksy_qr.png';

Font.register({
  family: FONT_FAMILY,
  fonts: [
    {
      src: `${POPPINS_FONT_BASE_URL}/Poppins-Light.ttf`,
      fontWeight: 300
    },
    {
      src: `${POPPINS_FONT_BASE_URL}/Poppins-Regular.ttf`,
      fontWeight: 400
    },
    {
      src: `${POPPINS_FONT_BASE_URL}/Poppins-Medium.ttf`,
      fontWeight: 500
    },
    {
      src: `${POPPINS_FONT_BASE_URL}/Poppins-SemiBold.ttf`,
      fontWeight: 600
    },
    {
      src: `${POPPINS_FONT_BASE_URL}/Poppins-Bold.ttf`,
      fontWeight: 700
    }
  ]
});

const boldPdfText = {
  fontFamily: FONT_FAMILY,
  fontWeight: 600,
  color: '#000000'
};

const semiBoldPdfText = {
  fontFamily: FONT_FAMILY,
  fontWeight: 600,
  color: '#000000'
};

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#b8d5e6',
    paddingTop: 50,
    paddingHorizontal: 35,
    paddingBottom: 56,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    color: '#000000'
  },
  header: {
    marginBottom: 16,
  },
  title: {
    fontSize: 24.75,
    fontWeight: 700,
    marginBottom: 12, 
  },
  section: {
    marginBottom: 4, 
  },
  label: {
    fontSize: 9,
    color: '#666666',
    marginBottom: 4, 
  },
  value: {
    fontSize: 10.5,
    marginBottom: 10, 
  },
  companyInfo: {
    fontSize: 10.5,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    lineHeight: 1.2,
    color: '#000000',
  },
  divider: {
    borderBottom: '1px solid #e0e0e0',
    marginVertical: 15, 
  },
   table: {
    width: '100%',
    marginTop: 24,
    marginBottom: 14,
  },
	  tableRow: {
	    flexDirection: 'row',
	    alignItems: 'flex-end',
	    paddingBottom: 4,
	    width: '100%',
	  },
	  groupedTableRow: {
	    flexDirection: 'row',
	    alignItems: 'stretch',
	    width: '100%',
	    borderBottomWidth: 1,
	    borderBottomColor: '#000000',
	    borderBottomStyle: 'solid',
	  },
	  tableHeaderRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
    paddingTop: 0,
    paddingBottom: 9,
  },
  tableHeaderCellWrap: {
    justifyContent: 'flex-end',
    paddingTop: 0,
    paddingBottom: 0,
  },
  tableHeaderCell: {
    fontSize: 9,
    ...semiBoldPdfText,
    textAlign: 'center',
    lineHeight: 1.2,
    paddingTop: 0,
    paddingBottom: 0,
  },
  tableCell: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    textAlign: 'left',
    lineHeight: 1.2,
    color: '#000000',
  },
	  tableCellBase: {
	    paddingRight: 2,
	  },
	  tableCellContent: {
	    paddingVertical: 5,
	  },
	  tableCellLast: {
	    paddingRight: 0,
	  },
  cameraCell: {
    paddingLeft: 3,
  },
  monitoringCell: {
    fontSize: 9.75,
    lineHeight: 1.3,
  },
  monitoringRow: {
    flexDirection: 'row',
    marginBottom: 2,
  },
  monitoringDay: {
    width: 50,
  },
  monitoringTime: {
    marginLeft: 8,
  },
  totalContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: 190,
  },
  totalLabels: {
    alignItems: 'flex-start',
    width: 120,
  },
  totalValues: {
    alignItems: 'flex-end',
    width: 70,
  },
  totalSummary: {
    width: 252,
  },
  totalSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
  },
  totalRowLabel: {
    width: 172,
  },
  totalRowValue: {
    width: 80,
  },
  totalLabel: {
    fontSize: 9.75,
    fontWeight: 700,
    marginBottom: 6, 
  },
  totalValue: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    color: '#000000',
    textAlign: 'right',
    lineHeight: 1.2,
    marginBottom: 9,
  },
  totalCreditHeading: {
    marginBottom: 4,
  },
  totalCreditDetailLabel: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    color: '#000000',
    lineHeight: 1.2,
    paddingLeft: 18,
    marginBottom: 6,
  },
  totalCreditDetailValue: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    color: '#000000',
    textAlign: 'right',
    lineHeight: 1.2,
    marginBottom: 6,
  },
  totalSummaryLabel: {
    fontSize: 9.75,
    //...boldPdfText,
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    color: '#000000',
    lineHeight: 1.2,
    marginBottom: 9,
  },
  totalRule: {
    borderTopWidth: 1,
    borderTopColor: '#000000',
    borderTopStyle: 'solid',
    width: 252,
    alignSelf: 'stretch',
    marginBottom: 8,
  },
  footer: {
    //marginTop: 10, 
    //paddingTop: 10, 
    borderTop: '1px solid #e0e0e0',
    fontSize: 9.75,
  },
  paymentTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 8, 
  },
  paymentText: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    lineHeight: 1.54,
    color: '#000000',
  },
  paymentDetailRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginLeft: 12,
    marginTop: 1,
    marginBottom: 1,
    paddingVertical: 0,
    
  },
  paymentBullet: {
    width: 5,
    marginRight: 4,
    fontSize: 9.75,
    lineHeight: 1.54,
    textAlign: 'center',
    color: '#000000',
  },
  paymentDetailText: {
    lineHeight: 1.1,
    marginTop: 0,
    marginBottom: 0,
  },
  paymentDetailMultilineText: {
    lineHeight: 1.35,
  },
  paymentNoteText: {
    paddingTop: 3,
    width: '100%',
  },
  siteName: {
    ...boldPdfText,
  },
	  headerDivider: {
	  borderBottomWidth: 1,
    borderBottomColor: '#000000',
    borderBottomStyle: 'solid',
    marginVertical: 0,
	  },
		  groupValuesContainer: {
		    flexDirection: 'column',
		    width: '100%',
		  },
		  groupValuesStack: {
		    alignSelf: 'stretch',
		    justifyContent: 'center',
		  },
		  groupValueBlock: {
		    flexDirection: 'row',
		    alignItems: 'stretch',
		    width: '100%',
		  },
		  groupValueColumn: {
		    flexDirection: 'column',
		    alignItems: 'center',
		    justifyContent: 'center',
		    alignSelf: 'stretch',
		  },
		  groupColumnValueCell: {
		    width: '100%',
		    justifyContent: 'center',
		    alignItems: 'center',
		    paddingVertical: 4,
		  },
		  groupSiteEntry: {
		    marginBottom: 8,
		  },
	  groupStaticCell: {
	    justifyContent: 'center',
	  },
	  numericCell: {
	  justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 1,
    paddingRight: 1,
    paddingVertical: 0,
	  },
  billToLabelWrap: {
    position: 'relative',
    marginBottom: 2,
  },
  billToLabel: {
    fontSize: 10.5,
    ...boldPdfText,
    textAlign: 'left',
    lineHeight: 1.2,
  },

  invoiceTitleWrap: {
    position: 'relative',
    width: 130,
    minHeight: 28,
  },

  invoiceLabel: {
    fontSize: 24.75,
    ...boldPdfText,
    textAlign: 'left',
    lineHeight: 1.2,
    width: 130,
  },
  companyName: {
    fontSize: 10.5,
    ...boldPdfText,
    lineHeight: 1.2,
  },
  invoiceNumberLabel: {
    fontSize: 12,
    ...boldPdfText,
    lineHeight: 1.2,
  },
  invoiceNumberLabelWrap: {
    width: 100,
  },
  invoiceNumberValue: {
    fontSize: 12,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    color: '#000000',
    lineHeight: 1.2,
    marginLeft: 0,
  },
  siteDetailBold: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    color: '#000000',
    lineHeight: 1.2,
  },
  paymentTitleWrap: {
    position: 'relative',
    marginBottom: 8,
    marginTop: 0,
  },
  paymentTitleText: {
    fontSize: 12,
    ...boldPdfText,
    lineHeight: 1.2,
  },
  billToText: {
    fontSize: 10.5,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    textAlign: 'left',
    color: '#000000',
    lineHeight: 1.2,
    marginBottom: 10,
  },
  clientIdValue: {
    fontSize: 10.5,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    textAlign: 'left',
    color: '#000000',
    lineHeight: 1.2,
    fontStyle: 'normal',
  },
  qrPaymentSection: {
    width: 252,
    marginTop: 22,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
  },
  qrPaymentTextBlock: {
    width: 122,
    paddingTop: 5,
    marginRight: 2,
  },
  qrPaymentText: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#000000',
  },
  qrPaymentCompany: {
    fontSize: 9.75,
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    lineHeight: 1.22,
    color: '#000000',
  },
  qrCodeImage: {
    width: 104,
    height: 104,
  },
			});

const InvoicePDF = ({ invoiceData }) => {

  
    console.log('Received invoiceData:', invoiceData);
  // Extract data from the array (first item)
  const data = invoiceData && invoiceData[0] ? invoiceData[0] : {};
  
  const {
    billto = '',
    footer = {},
    company = {},
    invoice = {},
    services = [],
    billing_id = 0
  } = data;

  // Format billto text - replace \\n with actual line breaks
  const formattedBillTo = billto ? billto.replace(/\\n/g, '\n') : '';
  const billingId =  billing_id ? billing_id : 0

  //console.log('ZELLE_QR_CODE_URL:', ZELLE_QR_CODE_URL);

  // Format company info
  const companyInfo = {
    name: company.name || '',
    poBox: company.address1 || '',
    city: company.address2 || '',
    country: company.country || '',
    phone: company.phone || '',
    email: company.email || ''
  };

  const formattedInvoiceNumber = (number) => {
    let data = number.split('_').join(' ')
    return data ? data.toString().padStart(6, '0') : '';
  };
  // Format invoice data
  const invoiceNumber = formattedInvoiceNumber(invoice.formatted_invoice_number) || formattedInvoiceNumber(invoice.number) || '';
  const formatDatePaid = (value) => {
    if (Array.isArray(value)) {
      return value
        .map((item) => String(item ?? '').trim())
        .filter(Boolean)
        .join(', ');
    }

    if (value === null || value === undefined) {
      return '';
    }

    return String(value).trim();
  };
  //let key, value;
  const datePaid = formatDatePaid(invoice.date_paid);
  const total = invoice.total || '0.00';
  const amountPaid = invoice.amount_paid || '0.00';
  const outstandingAmount = invoice.outstanding_amount || '0.00';
  const storageamount = invoice.total_storage_amount || '0.00';
  // if (data.invoice.invoice_additionals && Object.keys(data.invoice.invoice_additionals).length > 0) {
  //     [key, value] = Object.entries(data.invoice.invoice_additionals)[0];
  // }

 const additionalEntries = Object.entries(
  data.invoice.invoice_additionals || {}
);



  // Format payment methods from footer - without optional chaining
  const paymentMethods = {
    paypal: '',
    beneficiary: '',
    accountNumber: '',
    bankName: '',
    routingNumber: '',
    directDeposit: ''
  };

  // Extract payment methods safely
  if (footer && footer.methods && Array.isArray(footer.methods)) {
    const paypalMethod = footer.methods.find(m => m.text && m.text.includes('PayPal'));
    if (paypalMethod && paypalMethod.text) {
      paymentMethods.paypal = paypalMethod.text.replace('PayPal: ', '');
    }

    const bankMethod = footer.methods.find(m => m.type === 'bank');
    if (bankMethod && bankMethod.details && Array.isArray(bankMethod.details)) {
      bankMethod.details.forEach(detail => {
        if (detail.includes('Beneficiary')) {
          paymentMethods.beneficiary = detail.replace('Beneficiary Name: ', '');
        } else if (detail.includes('Account Number')) {
          paymentMethods.accountNumber = detail.replace('Account Number: ', '');
        } else if (detail.includes('Bank Name')) {
          paymentMethods.bankName = detail.replace('Bank Name: ', '');
        } 
        else if (detail.includes('Routing Number')) {
          paymentMethods.routingNumber = detail.replace('Routing Number (Domestic Wire): ', '');
        } 
        else if (detail.includes('Direct Deposits')) {
          paymentMethods.directDeposit = detail.replace('Direct Deposits / Electronic Payments: ', '');
        }
      });
    }
  }

  // Format services data for table
  // const formattedItems = services.map((service, index) => ({
  //   site: service.site_name || `Service ${index + 1}`,
  //   siteAddress: service.site_address || '',
  //   monitoringWindow: service.monitoring_hours ? service.monitoring_hours.replace(/\\n/g, '\n') : '',
  //   cameraUnits: service.units || '0',
  //   views: '', // This field seems not in your data
  //   credits: service.credits || '0',
  //   amount: service.amount ? `${service.amount}` : '$0',
  //   outstanding: service.outstanding_amount ? `${service.outstanding_amount}` : '0'
  // }));

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const formatMonth = (value) => {
    if (Array.isArray(value)) {
      return value
        .map(formatMonth)
        .filter(Boolean)
        .filter((month, index, months) => months.indexOf(month) === index)
        .join(', ');
    }

    if (value === null || value === undefined) {
      return '';
    }

    const valueString = String(value).trim();
    const valueParts = valueString
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);

    if (valueParts.length > 1) {
      return valueParts
        .map(formatMonth)
        .filter(Boolean)
        .filter((month, index, months) => months.indexOf(month) === index)
        .join(', ');
    }

    const monthNumber = Number(valueString);

    if (Number.isInteger(monthNumber) && monthNumber >= 1 && monthNumber <= 12) {
      return monthNames[monthNumber - 1];
    }

    return valueString;
  };

  const formatServiceMonthYear = (service) => {
    const formattedMonth = formatMonth(service.month ?? service.Month ?? '');
    // const yearValue = service.year ?? service.Year ?? invoice.year ?? invoice.Year ?? '';
    // const formattedYear = String(yearValue ?? '').trim();

    // if (!formattedMonth) {
    //   return formattedYear;
    // }

    // if (!formattedYear || /\b\d{4}\b/.test(formattedMonth)) {
    //   return formattedMonth;
    // }

    return `${formattedMonth}`;
  };

  const formatMonitoringHours = (value) => String(value || '')
    // The API can return either literal Unicode escapes or decoded dash characters.
    .replace(/\\u(?:2012|2013|2014|2015|2212)/gi, '-')
    .replace(/[\u2012-\u2015\u2212]/g, '-')
    .replace(/\\r\\n|\\r|\\n|\r\n|\r|\n/g, '\n')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trim())
    .filter(Boolean)
    .join('\n');

  // Format services data for table
const formattedItems = services.map((service, index) => {
  return {
    site: service.site_name || `Service ${index + 1}`,
    siteAddress: service.site_address || '',
    noOfCameras: service.no_of_cameras ?? '0',  // No of Cameras
    noOfViews: service.views ?? '0',  // Camera views
    viewsConsideredForBilling: service.views_considered_for_billing ?? '0',  // Views Considered
    credits: service.credits || '0',
    storageAmount: service.storage_amount ?? '0',
    amount: service.amount ? `${service.amount}` : '0',
    outstanding: service.outstanding_amount ? `${service.outstanding_amount}` : '0',
    billingsubId: service.client_id ? service.client_id : 0,
    month: formatServiceMonthYear(service),
    monitoring_hours: formatMonitoringHours(service.monitoring_hours),
    location: service.location ? service.location : ''
  };
});

console.log('formattedItems',formattedItems)
//isCreditsAvailable(formattedItems)


const getNumericAmount = (value) => {
  if (value === undefined || value === null || value === '') {
    return 0;
  }

  const amount = Number(String(value).replace(/[$,]/g, '').trim());
  return Number.isNaN(amount) ? 0 : amount;
};

const isNonZeroAmount = (value) => getNumericAmount(value) !== 0;

const isCreditsAvailable = (val) => {
  //console.log(formattedItems)
   const anyHasCredits = val.some(item => isNonZeroAmount(item.credits));

   return anyHasCredits;
}

const isStorageAvailable = (val) => {
  //console.log(formattedItems)
   const anyHasStorage = val.some(item => isNonZeroAmount(item.storageAmount ?? item.storage_amount));

   return anyHasStorage;
}
  // Calculate totals from services if not provided
  const calculatedTotal = services.reduce((sum, service) => sum + (service.amount || 0), 0);
  const calculatedOutstanding = services.reduce((sum, service) => sum + (service.outstanding_amount || 0), 0);
  
  const formatCurrency = (value) => {
    const num = Number(value) || 0;
    const abs = Math.abs(num).toFixed(2);
    return num < 0 ? `-$${abs}` : `$${abs}`;
  };

  const formatCreditCurrency = (value) => {
    const num = getNumericAmount(value);
    return num === 0 ? formatCurrency(0) : `-${formatCurrency(Math.abs(num))}`;
  };

  const creditDetails = Array.isArray(invoice.CreditDetails)
    ? invoice.CreditDetails
      .map((detail, index) => {
        const creditAmount = detail?.Credit ?? detail?.Credits ?? detail?.credits;
        const creditRemark = typeof detail?.Remarks === 'string' ? detail.Remarks.trim() : '';

        return {
          label: creditRemark || `Credit ${index + 1}`,
          amount: creditAmount
        };
      })
      .filter((detail) => (
        detail.amount !== undefined &&
        detail.amount !== null &&
        detail.amount !== '' &&
        isNonZeroAmount(detail.amount)
      ))
    : [];
  const hasCreditDetails = creditDetails.length > 0;

// Calculate which columns are visible
	const showBillSubId = formattedItems.length > 1;
	const showCredits = isCreditsAvailable(formattedItems);
  const showStorage = isStorageAvailable(formattedItems);
	const showMonth = formattedItems.some((item) => item.month !== null && item.month !== undefined && String(item.month).trim() !== '');

// Calculate dynamic widths
	const getColumnWidth = () => {
  const weights = {
    sNo: 8, 
    site: 35,
    billSubId: showBillSubId ? 13 : 0,
    month: showMonth ? 10 : 0,
    noOfCameras: 15,
    cameraViews: 14,
    viewsConsideredForBilling: 17,
    storage: showStorage ? 16 : 0,
    credits: showCredits ? 18 : 0,
    amount: 11
  };

  const totalWeight = Object.values(weights).reduce((sum, weight) => sum + weight, 0);
  const getWeightedWidth = (columnName) => (weights[columnName] / totalWeight) * 100;

  return {
    sNo: getWeightedWidth('sNo'),
    site: getWeightedWidth('site'),
    billSubId: showBillSubId ? getWeightedWidth('billSubId') : 0,
    month: showMonth ? getWeightedWidth('month') : 0,
    noOfCameras: getWeightedWidth('noOfCameras'),
    cameraViews: getWeightedWidth('cameraViews'),
    viewsConsideredForBilling: getWeightedWidth('viewsConsideredForBilling'),
    storage: showStorage ? getWeightedWidth('storage') : 0,
    credits: showCredits ? getWeightedWidth('credits') : 0,
    amount: getWeightedWidth('amount')
  };
};

const noHeaderHyphenation = (word) => [word];
const noQrTextHyphenation = (word) => [word];

const formatSingleLineFooterNote = (value) => (
  String(value || '').trim().replace(/\s+/g, '\u00a0')
);

const formatPaymentDetailText = (value) => {
  const detail = String(value || '').trim();
  const routingMatch = detail.match(/^Routing Number\s*(?:\(([^)]*)\))?\s*:\s*(.*)$/i);

  if (routingMatch) {
    const routingNumber = routingMatch[2].trim();
    const routingType = routingMatch[1] ? `\n(${routingMatch[1].trim()})` : '';
    return `Routing Number : ${routingNumber}${routingType}`;
  }

  const directDepositMatch = detail.match(/^(Direct Deposits\s*\/\s*Electronic Payments)\s*:\s*(.*)$/i);

  if (directDepositMatch) {
    return `${directDepositMatch[1]}:\n${directDepositMatch[2].trim()}`;
  }

  return detail;
};

const BoldTableHeader = ({ children, align = 'center', hyphenationCallback, style, wrap = true }) => {
  return (
    <Text
      wrap={wrap}
      hyphenationCallback={hyphenationCallback}
      style={[styles.tableHeaderCell, { textAlign: align, width: '100%' }, style]}
    >
      {children}
    </Text>
  );
};
	
const columnWidths = getColumnWidth();
const toPercentWidth = (value) => `${value}%`;
const valuesAreaWidth = 100
  - columnWidths.sNo 
  - columnWidths.site
  - (showBillSubId ? columnWidths.billSubId : 0);
const GROUP_ROW_MIN_HEIGHT = 20;
const valueColumnWidths = {
  month: showMonth ? (columnWidths.month / valuesAreaWidth) * 100 : 0,
  noOfCameras: (columnWidths.noOfCameras / valuesAreaWidth) * 100,
  cameraViews: (columnWidths.cameraViews / valuesAreaWidth) * 100,  // Camera views second
  viewsConsideredForBilling: (columnWidths.viewsConsideredForBilling / valuesAreaWidth) * 100,  // Third
  storage: showStorage ? (columnWidths.storage / valuesAreaWidth) * 100 : 0,
  credits: showCredits ? (columnWidths.credits / valuesAreaWidth) * 100 : 0,
  amount: (columnWidths.amount / valuesAreaWidth) * 100
};

const processGroupedItems = (formattedItems) => {
  const groups = [];
  let currentGroup = null;
  
  formattedItems.forEach((item, index) => {
    const billingsubId = String(item.billingsubId || '');
    const siteEntryKey = [
      item.site,
      item.location,
      item.siteAddress,
      item.monitoring_hours
    ].join('||');
    const itemWithSiteEntryKey = { ...item, siteEntryKey };
    
    if (!currentGroup || currentGroup.billingsubId !== billingsubId) {
      // Start new group
      currentGroup = {
        billingsubId: billingsubId,
        items: [itemWithSiteEntryKey],
        indices: [index],
        uniqueSiteEntries: [itemWithSiteEntryKey]
      };
      groups.push(currentGroup);
    } else {
      currentGroup.items.push(itemWithSiteEntryKey);
      currentGroup.indices.push(index);

      const hasExistingSiteEntry = currentGroup.uniqueSiteEntries.some(
        (existingItem) => existingItem.siteEntryKey === siteEntryKey
      );

      if (!hasExistingSiteEntry) {
        currentGroup.uniqueSiteEntries.push(itemWithSiteEntryKey);
      }
    }
  });
  
  return groups;
};

// Use this in your component:
const groups = processGroupedItems(formattedItems);

const getUniqueGroupMonths = (group) => group.items
  .map((item) => item.month)
  .filter(Boolean)
  .filter((month, index, months) => months.indexOf(month) === index);

const getMergedGroupMonth = (group) => {
  const months = getUniqueGroupMonths(group);

  return months.length === 1 ? months[0] : '';
};

const getValueColumnWidth = (columnName, isMonthMerged) => {
  if (!isMonthMerged) {
    return valueColumnWidths[columnName];
  }

  const remainingWidth = 100 - valueColumnWidths.month;
  return (valueColumnWidths[columnName] / remainingWidth) * 100;
};

const getGroupRowBlocks = (group, isMonthMerged) => {
  const blocks = [];

  group.items.forEach((item, itemIndex) => {
    const blockKey = showMonth && !isMonthMerged
      ? String(item.month || '')
      : 'same-row';
    const previousBlock = blocks[blocks.length - 1];

    if (!previousBlock || previousBlock.blockKey !== blockKey) {
      blocks.push({
        blockKey,
        month: item.month,
        startIndex: itemIndex,
        items: [item]
      });
      return;
    }

    previousBlock.items.push(item);
  });

  return blocks;
};

const renderValueColumn = (block, columnName, getDisplayValue, keyPrefix, isMonthMerged) => (
  <View
    key={`${keyPrefix}-${block.startIndex}`}
    style={[
      styles.tableCellBase,
      styles.groupValueColumn,
      {
        width: toPercentWidth(getValueColumnWidth(columnName, isMonthMerged)),
        minHeight: block.items.length * GROUP_ROW_MIN_HEIGHT
      }
    ]}
  >
    {block.items.map((item, itemIndex) => (
      <View
        key={`${keyPrefix}-${block.startIndex}-${itemIndex}`}
        style={[
          styles.groupColumnValueCell,
          { minHeight: GROUP_ROW_MIN_HEIGHT }
        ]}
      >
        <Text style={[styles.tableCell, { textAlign: 'center' }]}>
          {getDisplayValue(item)}
        </Text>
      </View>
    ))}
  </View>
);

const renderCreditsColumn = (block, isMonthMerged) => {
  const blockHeight = block.items.length * GROUP_ROW_MIN_HEIGHT;

  const creditItems = block.items.map((item) => ({
    value: item.credits,
    numericValue: getNumericAmount(item.credits),
    isNonZero: isNonZeroAmount(item.credits)
  }));

  const nonZeroCredits = creditItems.filter(
    (creditItem) => creditItem.isNonZero
  );

  // Check if all non-zero values are the same
  const allNonZeroValuesSame = nonZeroCredits.length > 0 && 
    nonZeroCredits.every(credit => credit.numericValue === nonZeroCredits[0].numericValue);
  
  const allValuesSame = creditItems.length > 0 && 
    creditItems.every(credit => credit.numericValue === creditItems[0].numericValue);

  // Case 1: All values are zero - show single zero
  const allZeroCredits = creditItems.length > 0 && nonZeroCredits.length === 0;
  
  if (allZeroCredits) {
    return (
      <View
        key={`credits-${block.startIndex}`}
        style={[
          styles.tableCellBase,
          styles.groupValueColumn,
          {
            width: toPercentWidth(getValueColumnWidth('credits', isMonthMerged)),
            minHeight: blockHeight
          }
        ]}
      >
        <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            0
          </Text>
        </View>
      </View>
    );
  }

  // Case 2: All non-zero values are the same and there's only one non-zero value
  if (nonZeroCredits.length === 1) {
    return (
      <View
        key={`credits-${block.startIndex}`}
        style={[
          styles.tableCellBase,
          styles.groupValueColumn,
          {
            width: toPercentWidth(getValueColumnWidth('credits', isMonthMerged)),
            minHeight: blockHeight
          }
        ]}
      >
        <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            {nonZeroCredits[0].value}
          </Text>
        </View>
      </View>
    );
  }

  // Case 3: All non-zero values are the same but there are multiple non-zero values
  // Show the value only once
  if (allNonZeroValuesSame && nonZeroCredits.length > 1) {
    return (
      <View
        key={`credits-${block.startIndex}`}
        style={[
          styles.tableCellBase,
          styles.groupValueColumn,
          {
            width: toPercentWidth(getValueColumnWidth('credits', isMonthMerged)),
            minHeight: blockHeight
          }
        ]}
      >
        <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            {nonZeroCredits[0].value}
          </Text>
        </View>
      </View>
    );
  }

  // Case 4: All values (including zeros) are the same
  if (allValuesSame) {
    return (
      <View
        key={`credits-${block.startIndex}`}
        style={[
          styles.tableCellBase,
          styles.groupValueColumn,
          {
            width: toPercentWidth(getValueColumnWidth('credits', isMonthMerged)),
            minHeight: blockHeight
          }
        ]}
      >
        <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            {creditItems[0].value}
          </Text>
        </View>
      </View>
    );
  }

  // Case 5: Multiple different non-zero values - show all values
  // But hide zero values if there's at least one non-zero in the block
  const hideZeroCredits = block.items.length > 1 && nonZeroCredits.length > 0;

  return (
    <View
      key={`credits-${block.startIndex}`}
      style={[
        styles.tableCellBase,
        styles.groupValueColumn,
        {
          width: toPercentWidth(getValueColumnWidth('credits', isMonthMerged)),
          minHeight: blockHeight
        }
      ]}
    >
      {creditItems.map((creditItem, itemIndex) => (
        <View
          key={`credits-${block.startIndex}-${itemIndex}`}
          style={[
            styles.groupColumnValueCell,
            { minHeight: GROUP_ROW_MIN_HEIGHT }
          ]}
        >
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            {hideZeroCredits && !creditItem.isNonZero ? '' : creditItem.value}
          </Text>
        </View>
      ))}
    </View>
  );
};

const renderStorageColumn = (block, isMonthMerged) => {
  const blockHeight = block.items.length * GROUP_ROW_MIN_HEIGHT;

  const storageItems = block.items.map((item) => ({
    value: item.storageAmount,
    isNonZero: isNonZeroAmount(item.storageAmount)
  }));

  const nonZeroStorageItems = storageItems.filter(
    (storageItem) => storageItem.isNonZero
  );

  if (nonZeroStorageItems.length === 0) {
    return (
      <View
        key={`storage-${block.startIndex}`}
        style={[
          styles.tableCellBase,
          styles.groupValueColumn,
          {
            width: toPercentWidth(getValueColumnWidth('storage', isMonthMerged)),
            minHeight: blockHeight
          }
        ]}
      >
        <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            0
          </Text>
        </View>
      </View>
    );
  }

  if (nonZeroStorageItems.length === 1) {
    return (
      <View
        key={`storage-${block.startIndex}`}
        style={[
          styles.tableCellBase,
          styles.groupValueColumn,
          {
            width: toPercentWidth(getValueColumnWidth('storage', isMonthMerged)),
            minHeight: blockHeight
          }
        ]}
      >
        <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            {nonZeroStorageItems[0].value}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <View
      key={`storage-${block.startIndex}`}
      style={[
        styles.tableCellBase,
        styles.groupValueColumn,
        {
          width: toPercentWidth(getValueColumnWidth('storage', isMonthMerged)),
          minHeight: blockHeight
        }
      ]}
    >
      {storageItems.map((storageItem, itemIndex) => (
        <View
          key={`storage-${block.startIndex}-${itemIndex}`}
          style={[
            styles.groupColumnValueCell,
            { minHeight: GROUP_ROW_MIN_HEIGHT }
          ]}
        >
          <Text style={[styles.tableCell, { textAlign: 'center' }]}>
            {storageItem.isNonZero ? storageItem.value : ''}
          </Text>
        </View>
      ))}
    </View>
  );
};

const renderThickSiteText = (value) => (
  <Text style={styles.siteDetailBold}>{value}</Text>
);

const formatAddressLines = (value) => {
  if (!value || !String(value).includes(',')) {
    return value;
  }

  return String(value)
    .split(',')
    .map((part, index, parts) => {
      const trimmedPart = part.trim();
      return index < parts.length - 1 ? `${trimmedPart},` : trimmedPart;
    })
    .filter(Boolean)
    .join('\n');
};
// const renderCreditsColumn = (block, isMonthMerged) => {
//   const blockHeight = block.items.length * GROUP_ROW_MIN_HEIGHT;

//   const creditItems = block.items.map((item) => ({
//     value: item.credits,
//     isNonZero: isNonZeroAmount(item.credits)
//   }));

//   const nonZeroCredits = creditItems.filter(
//     (creditItem) => creditItem.isNonZero
//   );

//   // NEW: all values are zero
//   const allZeroCredits =
//     creditItems.length > 0 && nonZeroCredits.length === 0;

//   // Show single non-zero value centered
//   if (block.items.length > 1 && nonZeroCredits.length === 1) {
//     return (
//       <View
//         key={`credits-${block.startIndex}`}
//         style={[
//           styles.tableCellBase,
//           styles.groupValueColumn,
//           {
//             width: toPercentWidth(
//               getValueColumnWidth('credits', isMonthMerged)
//             ),
//             minHeight: blockHeight
//           }
//         ]}
//       >
//         <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
//           <Text style={{ fontSize: 10, textAlign: 'center' }}>
//             {nonZeroCredits[0].value}
//           </Text>
//         </View>
//       </View>
//     );
//   }

//   // NEW: all zeros -> show single zero once
//   if (block.items.length > 1 && allZeroCredits) {
//     return (
//       <View
//         key={`credits-${block.startIndex}`}
//         style={[
//           styles.tableCellBase,
//           styles.groupValueColumn,
//           {
//             width: toPercentWidth(
//               getValueColumnWidth('credits', isMonthMerged)
//             ),
//             minHeight: blockHeight
//           }
//         ]}
//       >
//         <View style={[styles.groupColumnValueCell, { minHeight: blockHeight }]}>
//           <Text style={{ fontSize: 10, textAlign: 'center' }}>
//             0
//           </Text>
//         </View>
//       </View>
//     );
//   }

//   // Existing behavior
//   const hideZeroCredits =
//     block.items.length > 1 && nonZeroCredits.length > 0;

//   return (
//     <View
//       key={`credits-${block.startIndex}`}
//       style={[
//         styles.tableCellBase,
//         styles.groupValueColumn,
//         {
//           width: toPercentWidth(
//             getValueColumnWidth('credits', isMonthMerged)
//           ),
//           minHeight: blockHeight
//         }
//       ]}
//     >
//       {creditItems.map((creditItem, itemIndex) => (
//         <View
//           key={`credits-${block.startIndex}-${itemIndex}`}
//           style={[
//             styles.groupColumnValueCell,
//             { minHeight: GROUP_ROW_MIN_HEIGHT }
//           ]}
//         >
//           <Text style={{ fontSize: 10, textAlign: 'center' }}>
//             {hideZeroCredits && !creditItem.isNonZero
//               ? ''
//               : creditItem.value}
//           </Text>
//         </View>
//       ))}
//     </View>
//   );
// };
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={false}>
    
        <View style={styles.header}> 
  <View style={{ 
    flexDirection: 'row', 
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 26
  }}>
    <View style={{ flex: 1 }}>
      <View style={styles.invoiceTitleWrap}>
        <Text style={styles.invoiceLabel}>INVOICE</Text>
      </View>
    </View>
    
    <View style={{ 
      flex: 1, 
      alignItems: 'flex-end',
      justifyContent: 'flex-start' 
    }}>
      <Image 
        src={invoice.logo || '/static/logo-full.png'}
        style={{ width: 138, height: 50, objectFit: 'contain' }}
      />          
    </View>
  </View>      
  
  {(invoiceNumber || datePaid) && (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {invoiceNumber && (
        <>
          <Text style={[styles.invoiceNumberLabel, styles.invoiceNumberLabelWrap]}>
            Invoice number 
          </Text>
          <Text style={styles.invoiceNumberValue}>
            {`: ${invoiceNumber}`}
          </Text>
        </>
      )}
    </View>
  )}
</View>

     
       {/* Company Info and Bill To Side by Side */}
<View style={{ 
  flexDirection: 'row', 
  justifyContent: 'space-between',
  marginBottom: 0
}}>

  {/* Company Info - Left */}
  <View style={{ width: '45%' }}>
    <Text style={styles.companyName}>{companyInfo.name}</Text>
    <Text style={styles.companyInfo}>
      {companyInfo.poBox}{'\n'}
      {companyInfo.city}{'\n'}
      {companyInfo.country}{'\n'}
      {companyInfo.phone}{'\n'}
      {companyInfo.email}
    </Text>
  </View>

  {/* Bill To - Right */}
  <View style={{ width: '40%' }}>
   <View style={styles.billToLabelWrap}>
    <Text style={styles.billToLabel}>Bill to</Text>
   </View>


    <Text style={styles.billToText}>
      {formattedBillTo}
    </Text>

    {/* <View style={styles.billToLabelWrap}>
      <Text style={styles.billToLabel}>Client ID</Text>
    </View>
    <Text style={styles.clientIdValue}>
      {billingId}
    </Text> */}

   <View style={[styles.billToLabelWrap, { flexDirection: 'row', alignItems: 'center' }]}>
  <Text style={styles.billToLabel}>Client ID : </Text>
  <Text style={styles.clientIdValue}>{billingId}</Text>
</View>

  </View>

</View>

        
       

	       <View style={styles.table}>
  <View style={styles.tableHeaderRow}>
    <View style={[styles.tableHeaderCellWrap, { width: toPercentWidth(columnWidths.sNo), alignItems: 'center' }]}>
      <BoldTableHeader align="center">S.No</BoldTableHeader>
    </View>
    {/* Site & Address - Left aligned */}
    <View style={[styles.tableHeaderCellWrap, { width: toPercentWidth(columnWidths.site), alignItems: 'flex-start' }]}>
      <BoldTableHeader align="left">Site & Address</BoldTableHeader>
    </View>
    
    {/* Bill Sub Id */}
    {showBillSubId && (
      <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(columnWidths.billSubId) }]}>
        <BoldTableHeader>Client{'\n'}Sub ID</BoldTableHeader>
      </View>
    )}
    
    {/* All other columns */}
    <View style={{ flexDirection: 'row', flexGrow: 1, alignItems: 'stretch', width: toPercentWidth(valuesAreaWidth) }}>
      {showMonth && (
        <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.month) }]}>
          <BoldTableHeader hyphenationCallback={noHeaderHyphenation}>Service{'\n'}Month & Year</BoldTableHeader>
        </View>
      )}

       <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.noOfCameras) }]}>
        <BoldTableHeader hyphenationCallback={noHeaderHyphenation}>No{'\u00a0'}Of{'\n'}Cameras</BoldTableHeader>
      </View>

       <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.cameraViews) }]}>
        <BoldTableHeader>No Of{'\n'}Views</BoldTableHeader>
      </View>
      
     
                 
      <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.viewsConsideredForBilling) }]}>
        <BoldTableHeader>Views{'\n'}For{'\n'}Billing</BoldTableHeader>
      </View>
      
      {showStorage && (
        <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.storage) }]}>
          <BoldTableHeader hyphenationCallback={noHeaderHyphenation} wrap={false}>Storage ($)</BoldTableHeader>
        </View>
      )}
      
      {showCredits && (
        <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.credits) }]}>
          <BoldTableHeader
            hyphenationCallback={noHeaderHyphenation}
            wrap={false}
          >
            Credits ($)
          </BoldTableHeader>
        </View>
      )}
      
      <View style={[styles.numericCell, styles.tableHeaderCellWrap, { width: toPercentWidth(valueColumnWidths.amount) }]}>
        <BoldTableHeader>Amount($)</BoldTableHeader>
      </View>
    </View>
  </View>
  <View style={styles.headerDivider} />
  {groups.map((group, groupIndex) => {
    const mergedMonth = getMergedGroupMonth(group);
    const isMonthMerged = showMonth && Boolean(mergedMonth);
    const rowBlocks = getGroupRowBlocks(group, isMonthMerged);

     const sNo = groupIndex + 1;


    return (
      <View
        key={`${group.billingsubId}-${groupIndex}`}
        style={[
          styles.groupedTableRow,
          { minHeight: group.items.length * GROUP_ROW_MIN_HEIGHT }
        ]}
      >

            <View style={[
        styles.tableCellBase,
        styles.tableCellContent,
        styles.numericCell,
        {
          width: toPercentWidth(columnWidths.sNo),
          minHeight: group.items.length * GROUP_ROW_MIN_HEIGHT,
          justifyContent: 'center', // Changed from 'center' to 'flex-start'
          alignItems: 'center',
          //paddingTop: 5 // Add some padding from top
        }
      ]}>
        <Text style={[styles.tableCell, { textAlign: 'center' }]}>
          {sNo}
        </Text>
      </View>

        <View style={[
          styles.tableCellBase,
          styles.tableCellContent,
          {
            width: toPercentWidth(columnWidths.site),
            fontSize: 8.5,
            textAlign: 'left',
            minHeight: group.items.length * GROUP_ROW_MIN_HEIGHT,
          }
        ]}>
          {group.uniqueSiteEntries.map((siteEntry, siteIndex) => (
            <View
              key={`${siteEntry.siteEntryKey}-${siteIndex}`}
              style={siteIndex < group.uniqueSiteEntries.length - 1 ? styles.groupSiteEntry : null}
            >
              {renderThickSiteText(siteEntry.site)}
              {siteEntry.location && renderThickSiteText(siteEntry.location)}
              {siteEntry.siteAddress && <Text style={[styles.tableCell, { marginTop: 2 }]}>{formatAddressLines(siteEntry.siteAddress)}</Text>}
              {siteEntry.monitoring_hours && <Text style={[styles.tableCell, { marginTop: 2 }]}>{siteEntry.monitoring_hours}</Text>}
            </View>
          ))}
        </View>

        {showBillSubId && (
          <View style={[
            styles.tableCellBase,
            styles.tableCellContent,
            styles.groupStaticCell,
            styles.numericCell,
            {
              width: toPercentWidth(columnWidths.billSubId),
              minHeight: group.items.length * GROUP_ROW_MIN_HEIGHT,
            }
          ]}>
            <Text style={[styles.tableCell, { textAlign: 'center' }]}>{group.billingsubId}</Text>
          </View>
        )}

        <View style={[
          styles.groupValuesContainer,
          {
            flexGrow: 1,
            width: toPercentWidth(valuesAreaWidth),
            flexDirection: isMonthMerged ? 'row' : 'column',
            justifyContent: isMonthMerged ? 'flex-start' : 'center'
          }
        ]}>
          {showMonth && isMonthMerged && (
            <View style={[
              styles.tableCellBase,
              styles.tableCellContent,
              styles.groupStaticCell,
              styles.numericCell,
              {
                width: toPercentWidth(valueColumnWidths.month),
                minHeight: group.items.length * GROUP_ROW_MIN_HEIGHT,
              }
            ]}>
              <Text style={[styles.tableCell, { textAlign: 'center' }]}>{mergedMonth}</Text>
            </View>
          )}

          <View style={[
            styles.groupValuesContainer,
            styles.groupValuesStack,
            {
              flexGrow: 1,
              width: isMonthMerged
                ? toPercentWidth(100 - valueColumnWidths.month)
                : '100%'
            }
          ]}>
            {rowBlocks.map((block) => {
              const blockHeight = block.items.length * GROUP_ROW_MIN_HEIGHT;

              return (
                <View
                  key={`${group.billingsubId}-${block.startIndex}`}
                  style={[
                    styles.groupValueBlock,
                    {
                      flexGrow: rowBlocks.length === 1 ? 1 : 0,
                      minHeight: blockHeight
                    }
                  ]}
                >
                  {showMonth && !isMonthMerged && (
                    <View style={[styles.tableCellBase, styles.groupStaticCell, styles.numericCell, {
                      width: toPercentWidth(valueColumnWidths.month),
                      minHeight: blockHeight
                    }]}>
                      <Text style={[styles.tableCell, { textAlign: 'center' }]}>
                        {block.month}
                      </Text>
                    </View>
                  )}

                  {renderValueColumn(block, 'noOfCameras', (item) => item.noOfCameras, 'no-of-cameras', isMonthMerged)}
                  {renderValueColumn(block, 'cameraViews', (item) => item.noOfViews, 'camera-views', isMonthMerged)}
                 
                 
                  {renderValueColumn(block, 'viewsConsideredForBilling', (item) => item.viewsConsideredForBilling, 'views-considered', isMonthMerged)}
                  {showStorage && renderStorageColumn(block, isMonthMerged)}
                  {showCredits && renderCreditsColumn(block, isMonthMerged)}
                  {renderValueColumn(block, 'amount', (item) => item.amount, 'amount', isMonthMerged)}
                </View>
              );
            })}
          </View>
        </View>
      </View>
    );
  })}
</View>
        
        
        
        
        <View style={{ 
          flexDirection: 'row', 
          justifyContent: 'flex-start',
          marginBottom: 0
        }}>

        <View style={{ width: 245 }}>
               <View style={[styles.section]}>
          <View style={styles.paymentTitleWrap}>
            <Text style={styles.paymentTitleText}>
              {footer.title || 'Accepted Payment Methods'}
            </Text>
          </View>
         
          <View>
          {footer?.methods?.map((method, index) => (
            <View key={index} style={{ marginBottom: 2 }}>
              <Text style={styles.paymentText}>
                {index + 1}. {method.text}
              </Text>

              {method.type === 'bank' &&
                method.details?.map((detail, idx) => (
                  <View
                    key={idx}
                    style={styles.paymentDetailRow}
                  >
                    <Text style={styles.paymentBullet}>
                      {'\u2022'}
                    </Text>
                  

                    <Text
                      style={[
                        styles.paymentText,
                        styles.paymentDetailText,
                        formatPaymentDetailText(detail).includes('\n') ? styles.paymentDetailMultilineText : null
                      ]}
                    >
                      {formatPaymentDetailText(detail)}
                    </Text>
                  </View>
                ))}
            </View>
          ))}
        </View>
           <Text
             hyphenationCallback={noQrTextHyphenation}
             style={[styles.paymentText, styles.paymentNoteText]}
           >
             {formatSingleLineFooterNote(footer.note || `Note: All payments should be made to ${companyInfo.name}`)}
           </Text>
        </View>

        </View>

      
        <View style={{ width: 252, marginLeft: 28, alignItems: 'stretch' }}>
          <View style={styles.totalSummary}>
            <View style={styles.totalSummaryRow}>
              <Text style={[styles.totalSummaryLabel, styles.totalRowLabel]}>Amount</Text>
              <Text style={[styles.totalValue, styles.totalRowValue]}>{formatCurrency(total || calculatedTotal.toFixed(2))}</Text>
            </View>
            {hasCreditDetails && (
              <>
                <View style={styles.totalSummaryRow}>
                  <Text
                    style={[
                      styles.totalSummaryLabel,
                      styles.totalRowLabel,
                      styles.totalCreditHeading
                    ]}
                  >
                    Credits
                  </Text>
                </View>
                {creditDetails.map((creditDetail, index) => (
                  <View key={`${creditDetail.label}-${index}`} style={styles.totalSummaryRow}>
                    <Text style={[styles.totalCreditDetailLabel, styles.totalRowLabel]}>
                      {creditDetail.label}
                    </Text>
                    <Text style={[styles.totalCreditDetailValue, styles.totalRowValue]}>
                      {formatCreditCurrency(creditDetail.amount)}
                    </Text>
                  </View>
                ))}
              </>
            )}
            {additionalEntries.map(([key, value]) => (
              <View key={key} style={styles.totalSummaryRow}>
                <Text style={[styles.totalSummaryLabel, styles.totalRowLabel]}>
                  {key}
                </Text>
                <Text style={[styles.totalValue, styles.totalRowValue]}>
                  {formatCurrency(value)}
                </Text>
              </View>
            ))}
            {showStorage && (
              <View style={styles.totalSummaryRow}>
                <Text style={[styles.totalSummaryLabel, styles.totalRowLabel]}>Storage</Text>
                <Text style={[styles.totalValue, styles.totalRowValue]}>{formatCurrency(storageamount ?? storageamount)}</Text>
              </View>
            )}
            <View style={styles.totalSummaryRow}>
              <Text style={[styles.totalSummaryLabel, styles.totalRowLabel]}>Previous Balance Due</Text>
              <Text style={[styles.totalValue, styles.totalRowValue]}>{formatCurrency(outstandingAmount ?? calculatedOutstanding)}</Text>
            </View>
          </View>
           <View style={styles.totalRule} />
            <View style={styles.totalSummary}>
              <View style={styles.totalSummaryRow}>
                <Text style={[styles.totalSummaryLabel, styles.totalRowLabel, { marginBottom: 0 }]}>Total Amount</Text>
                <Text style={[styles.totalValue, styles.totalRowValue, { marginBottom: 0 }]}>{formatCurrency(amountPaid)}</Text>
              </View>
            </View>
            {/* {ZELLE_QR_CODE_URL && (
              <View style={styles.qrPaymentSection} wrap={false}>
                <View style={styles.qrPaymentTextBlock}>
                  <Text hyphenationCallback={noQrTextHyphenation} style={styles.qrPaymentText}>Send Money With Zelle{'\u00ae'}</Text>
                  <Text hyphenationCallback={noQrTextHyphenation} style={styles.qrPaymentText}>Scan in your banking</Text>
                  <Text hyphenationCallback={noQrTextHyphenation} style={styles.qrPaymentText}>app to pay</Text>
                  <Text hyphenationCallback={noQrTextHyphenation} style={styles.qrPaymentCompany}>VIDISKY INC</Text>
                  <Text hyphenationCallback={noQrTextHyphenation} style={styles.qrPaymentText}>at</Text>
                  <Text hyphenationCallback={noQrTextHyphenation} style={styles.qrPaymentText}>ramana@vdointel.com</Text>
                </View>
                <Image
                  src={ZELLE_QR_CODE_URL}
                  style={styles.qrCodeImage}
                />
              </View>
            )} */}
        </View>

        </View>

      </Page>
    </Document>
  );
};

export default InvoicePDF;
